import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Typography,
  IconButton,
  Pagination,
  Box,
  Grid,
  Button,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  styled,
} from "@mui/material";
import { Edit, Delete, Add } from "@mui/icons-material";
import NavigationTab from "../navigation";
import { Vehicle } from "./vehicleinterface";
import AddVehicleDialog from "./addvehicle";
import EditVehicleDialog from "./updatevehicle";
import UploadVehicleDialog from "./uploadvehicle";

const StyledTableCell = styled(TableCell)(() => ({
  fontWeight: "bold",
  color: "white",
}));

const VehicleListTable: React.FC = () => {
  const [vehicles, setVehicles] = useState<Vehicle[]>([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [loading, setLoading] = useState(false);

  const [totalCount, setTotalCount] = useState(0);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState<Vehicle | null>(null);
  const [statusDialogOpen, setStatusDialogOpen] = useState(false);
  const [vehicleToToggle, setVehicleToToggle] = useState<{
    id: number;
    status: boolean;
  } | null>(null);
  const [uploaddialogOpen, setUploadDialogOpen] = useState(false);

  const fetchVehicles = (currentPage: number) => {
    setLoading(true);
    const token = localStorage.getItem("token");

    if (!token) {
      console.error("No token found in localStorage");
      setLoading(false);
      return;
    }

    fetch(`${process.env.REACT_APP_API_BASE_URL}/vehicle`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": token,
      },
      body: JSON.stringify({
        pageNo: currentPage,
        pageSize: pageSize,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        const sortedVehicles = (data.items || []).sort(
          (a: Vehicle, b: Vehicle) => a.id - b.id
        );
        setVehicles(sortedVehicles);
        setTotalCount(data.totalCount || 0);
      })
      .catch((error) => console.error("Error fetching vehicles:", error))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchVehicles(page);
  }, [page, pageSize]);

  const handleVehicleAdded = () => {
    fetchVehicles(page);
  };

  const handleVehicleUpdated = () => {
    fetchVehicles(page);
  };

  const handleEditVehicle = (vehicle: Vehicle) => {
    setSelectedVehicle(vehicle);
    setEditDialogOpen(true);
  };

  const handleStatusChangeConfirm = () => {
    if (!vehicleToToggle) return;

    fetch(
      `https://kineticgreen-backend.navigolabs.com/user/userStatusChangeWTHT/${vehicleToToggle.id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ status: !vehicleToToggle.status }),
      }
    )
      .then((response) => response.json())
      .then(() => {
        fetchVehicles(page);
        setStatusDialogOpen(false);
      })
      .catch((error) => console.error("Error updating status:", error));
  };

  const handleStatusChangeRequest = (
    vehicleId: number,
    currentStatus: boolean
  ) => {
    setVehicleToToggle({ id: vehicleId, status: currentStatus });
    setStatusDialogOpen(true);
  };
  const handleNextPage = () => {
    setPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    setPage((prevPage) => Math.max(1, prevPage - 1));
  };

  return (
    <Box sx={{ background: "#1a1a1a", paddingBottom: 8 }}>
      <NavigationTab />
      <Grid container>
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "transparent",
          }}
        >
          <Box
            sx={{
              width: "1200px",
              background: "black",
              border: "1px solid white",
              borderRadius: "18px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px",
              }}
            >
              <Typography variant="h6" sx={{ color: "white" }}>
                Vehicle List
              </Typography>
              <Box>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<Add />}
                  sx={{
                    borderRadius: "20px",
                    background: "black",
                    color: "white",
                    border: "2px green solid",
                    mr: 2,
                  }}
                  onClick={() => setDialogOpen(true)}
                >
                  Add Vehicle
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<Add />}
                  sx={{
                    borderRadius: "20px",
                    background: "black",
                    color: "white",
                    border: "2px green solid",
                  }}
                  onClick={() => setUploadDialogOpen(true)}
                >
                  Upload Bulk Data
                </Button>
              </Box>
            </Box>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow sx={{ background: "green" }}>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Active/Inactive
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Vehicle Name
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Plate No
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      STATUS
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      ACTION
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {vehicles.map((vehicle, index) => (
                    <TableRow key={index}>
                      <StyledTableCell>
                        <Switch
                          checked={vehicle.status}
                          onChange={() =>
                            handleStatusChangeRequest(
                              vehicle.id,
                              vehicle.status
                            )
                          }
                          color="primary"
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Box sx={{ paddingRight: 3 }}>
                            <Avatar sx={{ bgcolor: "white", color: "black" }} />
                          </Box>
                          <Box sx={{ textAlign: "left" }}>
                            <Typography variant="body1" sx={{ color: "white" }}>
                              {vehicle.vehicle_model.model_name}
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ color: "lightgray" }}
                            >
                              ID {vehicle.id}
                            </Typography>
                          </Box>
                        </Box>
                      </StyledTableCell>
                      <StyledTableCell sx={{ color: "white" }}>
                        {vehicle.plate_no || "N/A"}
                      </StyledTableCell>
                      <StyledTableCell>
                        <Typography sx={{ color: "white" }}>
                          {vehicle.status ? "Active" : "Inactive"}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell>
                        <IconButton onClick={() => handleEditVehicle(vehicle)}>
                          <Edit sx={{ color: "white" }} />
                        </IconButton>
                        <IconButton>
                          <Delete sx={{ color: "white" }} />
                        </IconButton>
                      </StyledTableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box
              display="flex"
              justifyContent="flex-end"
              mt={2}
              mb={2}
              gap={1}
              sx={{ pr: 2 }}
            >
              <Button
                variant="contained"
                onClick={handlePrevPage}
                // disabled={page === 1 || loading}
                sx={{
                  borderRadius: "20px",
                  background: "black",
                  color: "white",
                  border: "2px green solid",
                  mr: 2,
                }}
              >
                Previous
              </Button>
              <Button
                variant="contained"
                onClick={handleNextPage}
                // disabled={loading || (models.length < pageSize && page > 1)}
                sx={{
                  borderRadius: "20px",
                  background: "black",
                  color: "white",
                  border: "2px green solid",
                  mr: 2,
                }}
              >
                Next
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>

      {/* Status Change Confirmation Dialog */}
      <Dialog
        open={statusDialogOpen}
        onClose={() => setStatusDialogOpen(false)}
      >
        <DialogTitle>Confirm Status Change</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to{" "}
            {vehicleToToggle?.status ? "deactivate" : "activate"} this vehicle?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setStatusDialogOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleStatusChangeConfirm} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <AddVehicleDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onVehicleAdded={handleVehicleAdded}
      />
      <UploadVehicleDialog
        open={uploaddialogOpen}
        onClose={() => setUploadDialogOpen(false)}
        onVehicleAdded={handleVehicleUpdated}
      />
      {/* <EditVehicleDialog
        open={editDialogOpen}
        onClose={() => setEditDialogOpen(false)}
        vehicle={selectedVehicle}
        onVehicleUpdated={handleVehicleUpdated}
      /> */}
    </Box>
  );
};

export default VehicleListTable;
